import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { create } from 'kts-scaffold-framework/utils/form';
import { connect } from 'kts-platform-frame/redux';
import language from 'kts-platform-frame/entry/Language';
import { IUserInfo } from 'kts-platform-frame/dataModel';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { passConfig } from 'kts-platform-frame/utils';
import {
    Card,
    Input,
    Button,
    Form,
    Row,
    Col,
    message,
    Icon,
} from 'antd';

const css = require('./index.scss');
const FormItem = Form.Item;

/** Redux接口 */
interface IReduxStatePart {
    userInfo?: IUserInfo;
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    userInfo: state.user.userInfo,
}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
        ModulesAction.passConfigGet();
    }

    /** 用户类型名称 */
    private get userTypeString(): string {
        const {userInfo} = this.props;
        const userTypeString: string = language.userTypeToString.get(userInfo.userType);
        return userTypeString || '未知';
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: { span: 10 },
            wrapperCol: { span: 14 }
        };
        const { userInfo } = this.props;
        const passConfigArr = this.modulesState.passConfigArr;
        return (
            <Card title="修改密码" className={css.info}>
                <div>
                    <Form
                        layout={"horizontal"}
                        onSubmit={this.handleSubmit}
                    >
                        <Row>
                            <Col span={20}>
                                <FormItem label="登录账号" {...formItemLayout}>
                                    {getFieldDecorator("userName", { initialValue: this.getLoginInfo() })(
                                        <Input disabled={true} />
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={20}>
                                <FormItem label="旧密码" {...formItemLayout}>
                                    {getFieldDecorator("oldPwd", {
                                        rules: [
                                            {
                                                required: true,
                                                message: "请输入旧密码"
                                            }
                                        ]
                                    })(<Input type="password" />)}
                                </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={20}>
                                <div>
                                    <FormItem label="新密码" {...formItemLayout}>
                                        {getFieldDecorator("newPwd", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: '请输入新密码',
                                                    // pattern: /(?!^(\d+|[a-zA-Z]+|[~!@#$%^&*?]+)$)^[\w~!@#$%^&*?]{6,20}$/,
                                                    // message: "由字母加数字或符号至少两种以上字符组成的6-20位半角字符，区分大小写",
                                                },
                                                {
                                                    validator: this.newPsdCheck
                                                }
                                            ]
                                        })(<Input onChange={this.newPasswordCheck} onFocus={this.newPasswordFocus} onBlur={this.newPasswordBlur} type="password"/>
                                            )}
                                    </FormItem>
                                        {
                                            (this.modulesState.newPasTipView && !this.modulesState.passConcigArrView) && <p className={css['mcn-tip']}>{this.modulesState.newPasTipMessage}</p>
                                        }
                                        {
                                            this.modulesState.passConcigArrView &&
                                            <div className={css['mcn-judge']}>
                                                {
                                                    passConfigArr && passConfigArr.map(el => {
                                                        return (
                                                            <span 
                                                                key={el['message']}
                                                                className={css['mcn-judge-info']}
                                                            >
                                                                {el['message']}
                                                                {
                                                                    el['statu'] ? <Icon type="zhengque"/> : <Icon type="cuowu"/>
                                                                }
                                                            </span>  
                                                        );
                                                    })
                                                }
                                            </div>
                                        }
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={20}>
                                <FormItem
                                    label="请重复新密码"
                                    {...formItemLayout}
                                >
                                    {getFieldDecorator("confirm", {
                                        rules: [
                                            {
                                                required: true, message: '请确认密码'
                                            },
                                            {
                                                validator: this.compareToFirstPassword,
                                            }
                                        ]
                                    })(<Input type="password" onBlur={this.handleConfirmBlur} />)}
                                </FormItem>
                            </Col>
                        </Row>
                        <Row className="text-center btns">
                            <Button type="primary" htmlType="submit">
                                提 交
                            </Button>
                            <Button type="default" className="ml-10" onClick={()=>{ history.back();}}>
                                返回
                            </Button>
                        </Row>
                    </Form>
                </div>
            </Card>
        );
    }
    /** 登录账号 */
    private getLoginInfo = () => {
        let { email, phone } = this.modulesState.accountInfo;
        return `${email} ${email && phone ? '/' : '' } ${phone}`;
    }
    private judgeSubmit = (opt) => {
        return opt['statu'] === true;    
    }

    private handleSubmit = (e): void => {
        e.preventDefault();
        let passConfigArr = this.modulesState.passConfigArr;
        let passConfigArrStatu = passConfigArr.every(this.judgeSubmit);
        this.props.form.validateFieldsAndScroll(async(err, values) => {
            if (!err && passConfigArrStatu) {
                if (values["newPwd"] !== values["confirm"]) {
                    message.warn("密码不一致");
                    return;
                }

                const ResetData = await ModulesAction.resetPsw(values["newPwd"], values["oldPwd"]);
                if (ResetData) {
                    message.success('操作成功');
                }
            }
        });
    }

    private newPasswordFocus = () => {
        ModulesAction.changeNewPasTipView(true);
        // ModulesAction.changePassConfigArrView(false);
    }

    private newPasswordBlur = () => {
        ModulesAction.changeNewPasTipView(false);
        ModulesAction.changePassConfigArrView(true);
        let newPwd = this.props.form.getFieldsValue(['newPwd']);
        const passConfigArr = passConfig(this.modulesState.passConfig, newPwd['newPwd']);
        ModulesAction.changePassConfigArr(passConfigArr);
    }

    private newPasswordCheck = (e) => {
        const value = e.target.value;
        const passConfigArr = passConfig(this.modulesState.passConfig, e.target.value);
        ModulesAction.changePassConfigArr(passConfigArr);
    }

    private handleConfirmBlur = () => {
        ModulesAction.updateConfirmDirty();
    }

    private compareToFirstPassword = (rule, value, callback) => {
        const form = this.props.form;
        if (value && value !== form.getFieldValue('newPwd')) {
            callback('两次密码不一致');
        } else {
            callback();
        }
    }

    private newPsdCheck = (rule, value, callback) => {
        let newPassword = this.props.form.getFieldsValue(['newPwd']);
        const passConfigArr = passConfig(this.modulesState.passConfig, newPassword['newPwd']);
        if (newPassword && this.modulesState.confirmDirty) {
            this.props.form.validateFields(['confirm'], {force: true}, () => {});
        }
        if (!passConfigArr.every(this.judgeSubmit)) {
            callback(' ');
        } else {
            callback();
        }
    }
}



// WEBPACK FOOTER //
// ./src/display/platform/UserCenter/UI.ResetPwd.tsx